import React from 'react'
import styles from './PageTab.css'

const PageTab = props => {
  const {
    dataAction,
    getLabel,
    label,
    isActive,
    handleOnClick,
  } = props

  const cn = isActive ? styles.activePageTab : styles.pageTab
  let btnLabel = label
  if (getLabel) {
    btnLabel = getLabel()
  }

  let dataActionValue = dataAction
  if (!dataActionValue && typeof btnLabel === 'string') {
    dataActionValue = btnLabel
  } else if (!dataAction) {
    dataActionValue = 'select'
  }
  dataActionValue = dataActionValue.replace(/\s/g, '-')

  return (
    <button
      className={cn}
      onClick={handleOnClick}
      data-action="tab-select"
      data-label={dataActionValue}
    >
      {btnLabel}
    </button>
  )
}

export default PageTab



// WEBPACK FOOTER //
// ./src/legacy/components/PageTab/PageTab.jsx